(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.updateHeights();

      window.matchMedia('(max-width: 990px)').addEventListener('change',()=>{
        this.updateHeights();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    calculateTotalHeight(selector){
      const sections = document.querySelectorAll(selector);
      let totalHeight = 0;
      sections.forEach(section => totalHeight += section.offsetHeight);
      return totalHeight;
    }

    /* All layout reads happen before any style write — a write between the
       two reads forces a second synchronous reflow. */
    updateHeights() {
      const headerHeight = this.header.offsetHeight;
      const totalHeight = this.calculateTotalHeight('.shopify-section.shopify-section-group-header-group');
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vap-age-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EXPIRY_DAYS = 30;

    function getStorageKey() {
      var el = document.getElementById('age-gate');
      return el ? el.dataset.storageKey : 'age-gate';
    }

    function isVerified(key) {
      try {
        var raw = localStorage.getItem(key);
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (Date.now() > data.expiry) {
          localStorage.removeItem(key);
          return false;
        }
        return data.verified === true;
      } catch (e) {
        return false;
      }
    }

    function setVerified(key) {
      var expiry = Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(key, JSON.stringify({ verified: true, expiry: expiry }));
    }

    function showGate() {
      var gate = document.getElementById('age-gate');
      if (!gate) return;

      var key = getStorageKey();
      if (isVerified(key)) return;

      gate.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      var confirmBtn = document.getElementById('age-gate-confirm');
      if (confirmBtn) {
        confirmBtn.focus();
        confirmBtn.addEventListener('click', function () {
          setVerified(key);
          gate.classList.add('age-gate--leaving');
          setTimeout(function () {
            gate.setAttribute('hidden', '');
            document.body.style.overflow = '';
          }, 320);
        });
      }
    }

    /* Delay until after first paint so LCP is not blocked by modal overlay */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(showGate, { timeout: 800 });
        } else {
          setTimeout(showGate, 150);
        }
      });
    } else {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(showGate, { timeout: 800 });
      } else {
        setTimeout(showGate, 150);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
